import React from 'react';
import ChatBox from './components/ChatBox';
import DocumentUploader from './components/DocumentUploader';

function App() {
  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <h1 className="text-center text-2xl font-bold mb-6">AI Document Assistant</h1>
      <DocumentUploader />
      <ChatBox />
    </div>
  );
}

export default App;

